<template>
    <form class="form__inner-form custom-facility-form">
        <ul class="form__list">
            <li class="form__item form__item--1/4 custom-facility-form__item custom-facility-form__item_first" v-if="typeLabel" key="facility-type_id">
                <v-select-public name="facility-type_id" :options="facilityTypes" v-model="facilityObj.type_id" v-validate="'required'" :label="typeLabel"></v-select-public>
            </li>

            <li class="form__item form__item--1/6 custom-facility-form__item custom-facility-form__item_second" key="facility_length">
                <v-numeric-field-public name="facility_length" v-model="facilityObj.length" v-validate="`decimal:2|min_value:0`" :label="lengthLabel" ></v-numeric-field-public>
            </li>

            <li class="form__item form__item--1/6 custom-facility-form__item custom-facility-form__item_third" key="facility_width">
                <v-numeric-field-public name="facility_width" v-model="facilityObj.width" v-validate="`decimal:2|min_value:0`" :label="widthLabel" ></v-numeric-field-public>
            </li>

            <li class="form__item form__item--1/3 custom-facility-form__item" key="description_nl">
                <v-textfield-public  v-model="facilityObj.description.nl" :label="descriptionLabel + ` Dutch`"></v-textfield-public>
            </li>

            <li class="form__item form__item--1/4 hide-on-mobile"></li>

            <li class="form__item form__item--1/6 hide-on-mobile"></li>

            <li class="form__item form__item--1/6 hide-on-mobile"></li>

            <li class="form__item form__item--1/3 custom-facility-form__item" key="description_en">
                <v-textfield-public  v-model="facilityObj.description.en" :label="descriptionLabel + ` English`"></v-textfield-public>
            </li>

            <li class="form__item form__item--1/6 custom-facility-form__item custom-facility-form__item_last" key="bold">
                <v-checkboxes name="bold" v-model="facilityObj.bold" :options="{1:boldLabel}" is-single-checkbox></v-checkboxes>
            </li>

            <li class="form__item form__item--1/4" v-if="!typeLabel" key="inner-button">
                <button @click="submitHandler" type="submit" class="form__button form__button--is-default">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    {{ submitButtonText }}
                </button>
            </li>
        </ul>

        <ul class="form__list" v-if="typeLabel" key="outer-button">
            <li class="form__item form__item--is-shrinking form__item--push-right">
                <button @click="submitHandler" type="submit" class="form__button form__button--is-default">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                 {{ submitButtonText }}
                </button>
            </li>
        </ul>
    </form>
</template>
<script>
import VSelect from './VSelect.vue';
import VTextfield from './VTextfield.vue';
import VCheckboxes from './VCheckboxes.vue';
import sweetalert from 'sweetalert';


  export default {
    $_veeValidate: {
      validator: 'new'
    },
    data () {
      return {
        facilityObj: {
          type_id: null,
          width: null,
          length: null,
          bold: null,
          description: {
            nl: null,
            en: null
          }
        }
      }
    },
    components: {
      VSelect,
      VTextfield,
      VCheckboxes
    },
    props: {
      facility: {
        default: () => {},
        type: Object
      },
      facilityTypes: {
        default: () => {},
        type: Object
      },
      submitButtonText: {
        default: '',
        type: String
      },
      typeLabel: {
        default: '',
        type: String
      },
      lengthLabel: {
        default: '',
        type: String
      },
      widthLabel: {
        default: '',
        type: String
      },
      boldLabel: {
        default: '',
        type: String
      },
      descriptionLabel: {
        default: '',
        type: String
      },
      updateCallback: {
        default: () => Promise.resolve(true),
        type: Function
      },
      submitCallback: {
        default: () => Promise.resolve(true),
        type: Function
      },
      formType: {
        default: 'submit',
        type: String
      }
    },
    methods: {
      scrollToNewForm() {
        let form = $('.custom-facility-form');
        let nav = $('.navbar-fixed');
        let margin = 156;
        if (nav.length > 0) {
          margin = nav.height() + 80;
        }
        let topPosition = $(form[form.length - 1]).offset().top - margin;
        $('html, body').animate({ scrollTop: topPosition }, 700);
      },
      submitHandler(event) {
        let that = this;
        if (event) event.preventDefault();
        that.$validator.validateAll().then(isValid => {
          if (isValid) {
            if (that.formType == 'update') {
              that.updateCallback(that.facilityObj).then(shouldReset => {
                if (shouldReset) {
                  that.facilityObj = {
                    type_id: null,
                    width: null,
                    length: null,
                    bold: null,
                    description: {
                      nl: null,
                      en: null
                    }
                  };
                  that.$validator.reset();
                }

              }, err => {

              });
            } else {
              that.submitCallback(that.facilityObj).then(shouldReset => {
                if (shouldReset) {
                  that.facilityObj = {
                    type_id: null,
                    width: null,
                    length: null,
                    bold: null,
                    description: {
                      nl: null,
                      en: null
                    }
                  };
                  that.$validator.reset();
                  that.scrollToNewForm();
                }

              }, err => {

              });
            }
          } else {
            that.$root.$emit('validation-error', that.$validator.errors);
            sweetalert('Error', 'The form contain errors!', 'error');
          }
        }, error => {

        });
      },
      submitPageHandler(event) {
        let that = this;

        if (event) event.preventDefault();

        if (that.formType == 'update') {
          that.$validator.validateAll().then(isValid => {
            if (isValid) {
              that.updateCallback(that.facilityObj).then(shouldReset => {
                if (shouldReset) {
                  that.facilityObj = {
                    type_id: null,
                    width: null,
                    length: null,
                    bold: null,
                    description: {
                      nl: null,
                      en: null
                    }
                  };
                  that.$validator.reset();
                }

              }, err => {

              });
            }
          });
        } else {
          if (that.facilityObj.type_id === undefined) return;
          that.$validator.validateAll().then(isValid => {
            if (isValid) {
              that.submitCallback(that.facilityObj).then(shouldReset => {
                if (shouldReset) {
                  that.facilityObj = {
                    type_id: null,
                    width: null,
                    length: null,
                    bold: null,
                    description: {
                      nl: null,
                      en: null
                    }
                  };
                  that.$validator.reset();
                  that.scrollToNewForm();
                }

              }, err => {

              });
            }
          });
        }
      }
    },
    watch: {
      facility: (value) => {
        this.facilityObj = Object.assign({}, value);
      }
    },
    created() {
      if (this.facility.description && this.facility.description.nl && this.facility.description.en) {
        this.facilityObj = Object.assign({}, this.facility);
      } else {
        let description = this.facility.description;
        this.facilityObj = Object.assign({}, this.facility);
        this.facilityObj.description = {
          nl: description && description.nl!==undefined?description.nl:description,
          en: description && description.en!==undefined?description.nl:''
        }
      }
      this.$root.$on('updateLandlordAndSubscription', () => {
          this.submitPageHandler();
      });
    }
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/admin/components/VFacilityFormPublic.vue